import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Cursos } from '@/features/cursos/componentes/Cursos';
import { rotaDeTela } from '@/features/permissoes/guardas';

const busca = z.object({
  busca: z.string().optional().catch(undefined),
  situacao: z.enum(['rascunho', 'publicado', 'arquivado']).optional().catch(undefined),
  visibilidade: z.enum(['privado', 'publico', 'pago']).optional().catch(undefined),
  categoria: z.enum(['treino', 'alimentacao', 'mentalidade', 'geral']).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  tags: z.string().optional().catch(undefined),
});

/** Cursos em vídeo (spec 019, CA-02). */
export const Route = createFileRoute('/_autenticado/cursos/')({
  ...rotaDeTela('cursos.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const filtros = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <Cursos
      filtros={filtros}
      aoMudarFiltros={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
